var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-sorting',{staticClass:"gl-flex gl-grow",attrs:{"text":_vm.sortText,"is-ascending":_vm.isDirectionAscending,"sort-options":_vm.sortOptions,"sort-by":_vm.orderBy,"dropdown-class":"gl-w-full","block":"","data-testid":"releases-sort"},on:{"sort-direction-change":_vm.onDirectionChange,"sort-by-change":_vm.onSortItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }